import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import { TableColumnsFilterComponent, Tables } from '../../../../../Components';
import {
  TableActions,
  ColumnsFilterPagesEnum,
  TableFilterTypesEnum,
  HighlightRowKeys,
  ActionsButtonsEnum,
} from '../../../../../Enums';
import {
  GlobalHistory,
  showError 
} from '../../../../../Helper';
import { ActiveItemActions } from '../../../../../store/ActiveItem/ActiveItemActions';
import { ClientsTrackingTableHeaderData } from './ClientsTrackingTableHeaderData';
import { TableColumnsFilterActions } from '../../../../../store/TableColumnsFilter/TableColumnsFilterActions';
import { ClientsTrackingManagementDialog } from "../ClientsTrackingManagementDialog/ClientsTrackingManagementDialog" ; 
 
 export const ClientsTrackingTableComponent = ({
  filter , 
  pathName ,
  clientTrackingTableFilter ,
  setFilter ,
  detailsClientTrackingList ,
  translationPath ,
  parentTranslationPath ,
  isClearFiltersClicked ,
  setIsClearFiltersClicked ,
  closeSideMenu , 
  onRowClick ,
  setSortBy ,
  sortBy  ,
  reloadData ,
  setClientTrackingTableFilter ,
  isFirst
}) => {
  const dispatch = useDispatch();
    const { t } = useTranslation(parentTranslationPath);
  
  const [tableColumns, setTableColumns] = useState([]);
  const [isOpenClientTrackingDialog, setIsOpenClientTrackingDialog] = useState(false);
  const [filterValues, setFilterValues] = useState({});
   const [vendorClientTrackingId, setVendorClientTrackingId] = useState(null);
  const [tableFilterData, setTableFilterData] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
   const [detailedCardAction, setdetailedCardAction] = useState(() => ({
    actionEnum: '',
    item: '',
  }));
  const [selectedTableFilterColumns, setSelectedTableFilterColumns] = useState(
    ClientsTrackingTableHeaderData(t).filter((item) => item.isDefaultFilterColumn).map((column) => column?.id)
  );
  const tableColumnsFilterResponse = useSelector((state) => state.TableColumnsFilterReducer);
  const [defaultPrefernces, setDefaultPrefernces] = useState([
    {
      enum: TableActions.openFile.key,
    },
  ]);
  const [activePrefernces, setActiveprefernces] = useState(defaultPrefernces);


  //  useEffect(() => {
  //    if (filterValues && Object.keys(filterValues).length > 0) {
  //      Object.values(filterValues).map((item, index) => {
  //        setFilter((i) => ({
  //          ...i,
  //          [item.displayPath]: item.value,
  //        }));
  //      });
  //    }
  //  }, [filterValues]);



  const tableActionClicked = useCallback(
    async (actionEnum, item, focusedRow, event) => {
      event.stopPropagation();
      event.preventDefault();
      setActiveItem(item);
      dispatch(ActiveItemActions.activeItemRequest(item));
     if (actionEnum === TableActions.openFile.key && item.vendorClientTrackingId) 
      {
        setIsOpenClientTrackingDialog(true);
        setVendorClientTrackingId(item.vendorClientTrackingId);

       } 
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, pathName]
  );

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };

  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));

  };



  useEffect(() => {
    if (
      tableColumnsFilterResponse && tableColumnsFilterResponse[ColumnsFilterPagesEnum.ClientsTracking.key] 
    ) {
      setSelectedTableFilterColumns(
        tableColumnsFilterResponse && tableColumnsFilterResponse[ColumnsFilterPagesEnum.ClientsTracking.key] 
      );
    }
  }, [tableColumnsFilterResponse]);

  useEffect(() => {
    setTableColumns([
      ...ClientsTrackingTableHeaderData(t).filter(
        (item) => selectedTableFilterColumns.findIndex((element) => element === item?.id) !== -1
      )
        .map((field) => ({
          id: field?.id || null,
          key: field?.input || null,
          isDate: field?.isDate || false, 
          label: field?.label || field.input ,
          input: field?.input || field.searchableKey,
          isNumber: field?.fieldType === 'number'  || field?.isNumber || false,  
          isSortable: field?.isSortable || false,
          isHiddenFilter: field?.isHiddenFilter || false,
          isDefaultFilterColumn: field?.isDefaultFilterColumn || false,
          searchableKey: field?.searchableKey,
          displayPath: field?.displayPath || field.input || null,
          fieldType: field?.fieldType || null,
          component: field?.component || ((item) => <div>{item[field.input] || ""}</div>),
          positiveNumber: (field.positiveNumber) || false  , 
          textInputType: field.textInputType || (field.isNumber ? 'number' : 'text') ||(field.fieldType === 'number' ? 'number' : 'text'),
          textInputMax: field.textInputMax,
          textInputMin: field.textInputMin,

        })),
    ]);

  }, [ selectedTableFilterColumns ,ClientsTrackingTableHeaderData]);

  const onFilterValuesChanged =(newValue) => {
    const localFilterDto = filter || {};
    if (newValue) {
      Object.values(newValue)
        .filter((item) => item.searchableKey || item.displayPath)
        .map((item) => {
          if (localFilterDto[item.displayPath])
            localFilterDto[item.displayPath] =
              item?.value && item.value !== "" ? item.value : null;
          else if (item.value)
            localFilterDto[item.displayPath] =
              item?.value && item.value !== "" ? item.value : null;
        });
    }
      setFilter({
        ...filter,
        ...localFilterDto,
        pageIndex: 0,
      });
   
    };
  

    useEffect(() => {
      setTableFilterData(
        tableColumns.map((column) => ({
          key: column.key || column.fieldKey || column.id,
          filterType:
            (column.isDate && TableFilterTypesEnum.datePicker.key) ||
            (column.withSelectFilter &&
              TableFilterTypesEnum.selectOption.key) ||
            (column.isNumber && TableFilterTypesEnum.numberInput.key) ||
            TableFilterTypesEnum.textInput.key,
          isHiddenFilter: column.isHiddenFilter,
          textInputType: column.textInputType,
          textInputMax: column.textInputMax,
          textInputMin: column.textInputMin,
          displayPath: column.input,
          isNumerInput : column.isNumber,
          positiveNumber: (column.positiveNumber) || false  , 

        }))
      );
    }, [tableColumns]);

  return (
    <div className="w-100 px-3">
      <TableColumnsFilterComponent
        columns={ClientsTrackingTableHeaderData(t)
          .filter((item) => !item.isHidden)
          .map((item) => ({
            key: item.id || item.input,
            value: item.label || item.input,
          }))}
        selectedColumns={selectedTableFilterColumns}
        onSelectedColumnsChanged={(newValue) => {
          setSelectedTableFilterColumns(newValue);
          let localTableColumnsFilterResponse = tableColumnsFilterResponse;
          if (localTableColumnsFilterResponse)
            localTableColumnsFilterResponse[
              ColumnsFilterPagesEnum.ClientsTracking.key
            ] = newValue;
          else {
            localTableColumnsFilterResponse = {
              [ColumnsFilterPagesEnum.ClientsTracking.key]: newValue,
            };
          }
          dispatch(
            TableColumnsFilterActions.TableColumnsFilterRequest(
              localTableColumnsFilterResponse
            )
          );
        }}
        parentTranslationPath={parentTranslationPath}
        translationPath=""
      />
      <Tables
        data={detailsClientTrackingList.result}
        headerData={tableColumns}
        filterData={tableFilterData}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
        defaultActions={activePrefernces}
        actionsOptions={{
          onActionClicked: tableActionClicked,
        }}
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        totalItems={detailsClientTrackingList.totalCount}
        isWithFilter
        onFilterValuesChanged={onFilterValuesChanged}
        filterValues={clientTrackingTableFilter}
        setSortBy={setSortBy}
        FilterDisabledButton={true}
        setIsClearFiltersClicked={setIsClearFiltersClicked}
        isClearFiltersClicked={isClearFiltersClicked}

      />


      {
        isOpenClientTrackingDialog && (
          <ClientsTrackingManagementDialog
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isOpen={isOpenClientTrackingDialog}
            onClose={() => {
              setIsOpenClientTrackingDialog(false);
              setVendorClientTrackingId(null);
            }}
            onSave={(updateData) => {
              setIsOpenClientTrackingDialog(false);
              setVendorClientTrackingId(null);
              if (updateData) {
                reloadData();
                setIsOpenClientTrackingDialog(false);
                setVendorClientTrackingId(null);


              }
            }}
            vendorClientTrackingId={vendorClientTrackingId}
          />
        )
      }
    </div>
  );
};
